module.exports = __webpack_public_path__ + "img/logo.d41b3a4f.png";